<template>
	<textarea v-if="itype=='textarea'" class="form-control" :rows="iRow" :disabled="disabled" :value="val"></textarea>
	<input v-else :type="type" :class="[setSize]" class="form-control" :disabled="disabled" :value="val" :placeholder="placeholder" />
</template>

<script>
	import bsfBtn from './btn'
	export default {
		name: 'bsf-input',
		components: {},
		props: {
			disabled: {
				type: Boolean,
				default: false
			},
			val: {
				type: [String,Array],
			},
			placeholder: {
				type: String,
			},
			size: {
				type: String,
			},
			csize: {
				type: String,
			},
			col: {
				type: [Number, String],
			},
			itype: {
				type: String,
				default: "text"
			},
			psd: {
				type: Boolean,
			},
			row: {
				type: [Number, String],
			}
		},
		data: function() {
			return {
				feedback: false,
			}
		},
		mounted: function() {
			this.$nextTick(function() {})
		},
		computed: {
			iRow() {
				return parseInt(this.row, 10);
			},
			type() {
				return this.psd ? 'password' : 'text';
			},
			setSize() {
				return this.size ? ('input-' + this.size) : '';
			}
		},
		watch:{
			value(v){
				this.$emit('input',v)
			}
		}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../../assets/lib/css.less";
	.form-control {
		.unbdr;
	}
</style>


// WEBPACK FOOTER //
// input.vue?c0cbed82